import { Map } from 'immutable';

import * as t from '../../actions/friendProfileActionType';

const initialState = Map({
  friendActivityData: {
    totalQuestion: 100,
    questionCounter: 10,
    percentile: 10,
  },
});

const reducer = function friendActivityReducer(state = initialState, action) {
  switch (action.type) {
    case t.SET_FRIEND_ACTIVITY:
      return state.set('friendActivityData', action.friendActivityData);
    default:
      return state;
  }
};

export default reducer;
